import { LoginCred } from "modules/register-login";
import { API_endpoints } from "../config"; 

export const registerUser = async (registerData: LoginCred): Promise<void> => {
    try {
        const response = await fetch(API_endpoints.rigisteSubmit, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            credentials: 'include',
            body: JSON.stringify(registerData),
        });

        if (!response.ok) {
            const data = await response.json();
            throw new Error(data.message || "Fehler beim Registrieren.");
        }
        
        
    } catch (error) {
        console.error("Fehler beim Registrieren:", error);
        throw error;
    }
};
